import { event } from "./gtag"
import ROLE from "../utils/constant"

// Sign-up funnel events. `source` is "page" (/sign-up) or "modal" (the
// sign-up overlay); their steps are numbered differently, so each has its
// own names. Category is signup_<source>; label is <role>:<step name>.
const STEP_NAMES = {
  page: {
    [ROLE.cofounder]: ["account", "verify_email", "profile", "premium", "done"],
    [ROLE.vendor]: ["account", "verify_email", "intro", "company", "profile"],
  },
  modal: {
    [ROLE.cofounder]: ["account", "verify_email", "intro", "startup", "profile"],
    [ROLE.vendor]: ["account", "verify_email", "intro", "company", "profile"],
  },
}

const stepName = (source, role, page) =>
  ((STEP_NAMES[source] || {})[role] || [])[page - 1] || `step_${page}`

export const trackSignupStart = (source) =>
  event({ action: "signup_start", category: `signup_${source}` })

// fire when the user completes `page` and moves on
export const trackSignupStep = (source, role, page) =>
  event({
    action: "signup_step",
    category: `signup_${source}`,
    label: `${role}:${stepName(source, role, page)}`,
  })

export const trackSignUp = (source, role) =>
  event({ action: "sign_up", category: `signup_${source}`, label: role })
